import { AfterViewInit, Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup, ReactiveFormsModule, FormsModule } from '@angular/forms';

import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MessageService } from '../../services/message.service';

import { LocationStrategy, CommonModule } from '@angular/common';

import { PerfectScrollbarConfigInterface } from "ngx-perfect-scrollbar";

import { SearchData } from 'src/app/services/searchData';
import { BussinessPostComponent } from '../bussiness-post/bussiness-post.component';
import { WidgetModule } from '../../widget/widget.module';
import { RecruiterDashboardComponent } from '../../features/dashboards/recruiter-dashboard/recruiter-dashboard.component';
import { BenchSalesDashboardComponent } from '../../features/dashboards/bench-sales-dashboard/bench-sales-dashboard.component';
import { HomeTabStateService } from '../../features/dashboards/home-tab-state.service';
import { UserBadgeComponent } from './user-badge/user-badge.component';
import { InviteColleaguesComponent } from '../../features/activity-feed/invite-colleagues/invite-colleagues.component';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';


@Component({
  selector: 'app-landing-page',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormsModule, BussinessPostComponent, WidgetModule, RecruiterDashboardComponent, BenchSalesDashboardComponent, UserBadgeComponent, InviteColleaguesComponent, NG_ICON_DIRECTIVES],
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss']
})
export class LandingPageComponent implements OnInit, AfterViewInit {

  /** Which dashboards this user type may access. Recruiter/Bench tabs are
   *  mutually gated; JOB_SEEKER (and anyone not on the allow-lists) sees only
   *  the Activity Feed. Values match the backend userType constants exactly. */
  private readonly userType = (localStorage.getItem('userType') || '').trim();
  readonly canShowRecruiter =
    ['MANAGEMENT_TALENT_ACQUISITION', 'RECRUITER', 'FREELANCE_RECRUITER']
      .includes(this.userType);
  readonly canShowBench =
    ['MANAGEMENT_TALENT_ACQUISITION', 'FREELANCE_RECRUITER', 'BENCH_RECRUITER']
      .includes(this.userType);

  /** Tabs rendered on /landingPage. URL drives this (and vice-versa). */
  private readonly VALID_TABS = ['recruiter', 'bench', 'feed'] as const;
  activeTab: 'recruiter' | 'bench' | 'feed' = this.defaultTab();

  /** Default landing tab is role-based: recruiter users see the Recruiter
   *  Dashboard, bench-sales / MTA / freelance recruiters see the Bench
   *  Sales Dashboard, everyone else (incl. JOB_SEEKER, student) sees the
   *  Activity Feed. The welcome-tour modal still fires on any
   *  `/landingPage/*` URL — when the user clicks "Take a Tour" we switch
   *  to the feed tab in `startUI` so `step.userbadge` has a real target. */
  private defaultTab(): 'recruiter' | 'bench' | 'feed' {
    if (this.canShowRecruiter) return 'recruiter';
    if (this.canShowBench) return 'bench';
    return 'feed';
  }

  /** Set true briefly to force the active dashboard child component to
   *  unmount/remount when the user clicks the already-active nav tab —
   *  acts as a "soft reload" so data re-fetches from the API. */
  reloading = false;

  selectTab(tab: 'recruiter' | 'bench' | 'feed') {
    if (tab === 'recruiter' && !this.canShowRecruiter) return;
    if (tab === 'bench' && !this.canShowBench) return;

    if (tab === this.activeTab) {
      // Same-tab click — remount the active dashboard and scroll to top.
      this.reloading = true;
      setTimeout(() => {
        this.reloading = false;
        this.scrollLandingToTop();
      }, 0);
      return;
    }

    this.activeTab = tab;
    this.homeTabs.setActiveTab(tab);
    // Push a new history entry so the browser back button returns to the
    // previously-active tab.
    this.router.navigate(['/landingPage', tab]);
    this.scrollLandingToTop();
  }

  private scrollLandingToTop(): void {
    try {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch {
      window.scrollTo(0, 0);
    }
  }

  /** Pull the tab out of the URL and sync `activeTab`. If the URL has no
   *  tab segment (bare `/landingPage`), or requests a tab the user doesn't
   *  have access to, redirect to the default tab with `replaceUrl: true`
   *  so the invalid/empty URL doesn't pollute history. */
  private syncTabWithUrl(urlSegment: string | undefined): void {
    const wanted = (urlSegment || '').toLowerCase();
    const isValid = (this.VALID_TABS as readonly string[]).includes(wanted);
    const blockedByAccess =
      (wanted === 'recruiter' && !this.canShowRecruiter) ||
      (wanted === 'bench' && !this.canShowBench);

    if (!isValid || blockedByAccess) {
      // Post deep links (notifications: /landingPage?postId=…) must land on the
      // Activity Feed whatever the role's default tab, and keep the query string
      // so bussiness-post can pin that post — the redirect used to drop both.
      const hasPostId = !!this.route.snapshot.queryParamMap.get('postId');
      const fallback = hasPostId ? 'feed' : this.defaultTab();
      this.activeTab = fallback;
      this.homeTabs.setActiveTab(fallback);
      this.router.navigate(['/landingPage', fallback], { replaceUrl: true, queryParamsHandling: 'preserve' });
      return;
    }

    this.activeTab = wanted as 'recruiter' | 'bench' | 'feed';
    this.homeTabs.setActiveTab(this.activeTab);
  }

  @ViewChild('landingside1') menuElement: ElementRef;
  @ViewChild('landingside2') menuElement1: ElementRef;
  @ViewChild('businessmenusticky') menuElements: ElementRef;

  businessmenustick: boolean = false;
  landingsidesticky1: boolean = false;
  landingsidesticky2: boolean = false;
  elementPosition: any;
  studentFlag: boolean = false
  schoolName: any;
  connectionRequest: UntypedFormGroup;
  Streamform: UntypedFormGroup;
  landingPageUserDatails;
  otherData: any;
  place: any;
  img: any = {};
  userDetailsLanding: any;
  userDetailsLanding_array = [];
  userName: any;

  userId: any;
  showhide = false;
  mystreams = false;
  mynetwork = false;
  todaystoppick = false;
  mycommunities = false;
  businessPage = false;
  tag = false;
  businessdetail;

  communityDetails;
  commLength;
  comm;
  commContent: any[];

  showLessCommunity = false;
  showMoreCommunity = false;

  startPageCom: number;
  paginationLimitCom: number;

  startPageBus;
  paginationLimitBus;
  stickyPosition: any;
  showLessBus = false;
  clickEventsubscription: Subscription;
  landingsidesticky3: boolean = false;
  public config: PerfectScrollbarConfigInterface = {};

  constructor(private router: Router, private route: ActivatedRoute, private location: LocationStrategy, private message: MessageService, private searchData: SearchData,
    private homeTabs: HomeTabStateService
  ) {
    this.homeTabs.setActiveTab(this.activeTab);
    this.searchData.getSticky().subscribe(res => {
      if (res.position) {
        this.stickyPosition = res.position
      }
    })

    // NOTE: removed the legacy `history.pushState` + `onPopState` hack that
    // re-pushed state on every back navigation — it disabled the browser
    // back button across the entire /landingPage shell. With URL-driven
    // tabs, back/forward should naturally move between tabs.
  }

  ngAfterViewInit() {
    window.scrollTo(0, 0);
  }

  ngOnInit() {
    this.message.success('Sign In successfully')
    localStorage.removeItem("isJoined");
    this.userId = localStorage.getItem('userId');
    // // this.router.routeReuseStrategy.shouldReuseRoute = () => false;

    // URL ↔ tab sync. Fires once on first load and again on every
    // in-app navigation under /landingPage (including back/forward).
    this.route.url.subscribe(segments => {
      this.syncTabWithUrl(segments[0]?.path);
    });
  }

  /** Right-rail sticky-class flags (kept intact from the pre-transformation
   *  implementation). Toggles `.sticky-widget-freelancer` /
   *  `.sticky-widget-other-users` on `.all-page-widget` based on
   *  scroll position + userType. The classes themselves now apply
   *  top-anchored CSS sticky (see landing-page.component.scss) instead
   *  of the legacy bottom-anchored negative-top values, so crossing the
   *  threshold no longer causes a layout jump. */
  freelancer: boolean = false;
  otherusertypes: boolean = false;
  private readonly STICKY_SCROLL_THRESHOLD_PX = 300;

  @HostListener('window:scroll')
  handleScroll() {
    // Only activate sticky on the activity-feed tab — the dashboard tabs
    // don't render `.af-right`.
    if (this.activeTab !== 'feed') {
      if (this.freelancer || this.otherusertypes) {
        this.freelancer = false;
        this.otherusertypes = false;
      }
      return;
    }

    const windowScroll = window.pageYOffset || document.documentElement.scrollTop;

    if (windowScroll >= this.STICKY_SCROLL_THRESHOLD_PX) {
      if (localStorage.getItem('userType') === 'FREELANCE_RECRUITER') {
        if (!this.freelancer || this.otherusertypes) {
          this.freelancer = true;
          this.otherusertypes = false;
        }
      } else {
        if (this.freelancer || !this.otherusertypes) {
          this.freelancer = false;
          this.otherusertypes = true;
        }
      }
    } else if (this.freelancer || this.otherusertypes) {
      this.freelancer = false;
      this.otherusertypes = false;
    }
  }

}

